(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ds-free-shipping"] && !Shopify.designMode) return;
  try {
    /* <ds-free-shipping>: l'istanza del drawer (data-sync="source") manda il proprio corpo a ogni
     connectedCallback, cioè al caricamento e a ogni ricostruzione del drawer (theme.js: renderContents,
     cart-drawer-items); quelle della scheda prodotto (data-sync="follow") lo copiano sul posto nel proprio
     corpo. Nessun calcolo, nessun testo, nessuna richiesta. Listener tolto in disconnectedCallback. */
  if (!customElements.get('ds-free-shipping')) {
    customElements.define('ds-free-shipping', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.sync === 'source') {
          const body = this.querySelector(':scope > .ds-fs__body');
          if (body) document.dispatchEvent(new CustomEvent('ds:free-shipping', { detail: { body: body.cloneNode(true) } }));
        } else if (this.dataset.sync === 'follow' && !this.onSync) {
          this.onSync = (event) => {
            const mine = this.querySelector(':scope > .ds-fs__body');
            const theirs = event.detail && event.detail.body;
            if (!mine || !theirs || mine.outerHTML === theirs.outerHTML) return;
            mine.dataset.state = theirs.dataset.state;
            mine.style.cssText = theirs.style.cssText;
            mine.innerHTML = theirs.innerHTML;
          };
          document.addEventListener('ds:free-shipping', this.onSync);
        }
      }
      disconnectedCallback() {
        if (this.onSync) {
          document.removeEventListener('ds:free-shipping', this.onSync);
          this.onSync = null;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
